import { useState } from "react";
import Slider from "react-slick";
import { useQuery } from "react-query";
import { getMainBanner, getMainNews } from "../../service";
import { Box, Button, Flex, Heading, Image, Link, Text, Center, FormControl, Input, useMediaQuery, Badge, FormErrorMessage, useToast } from "@chakra-ui/react";
import Tab from "../../Component/Tab";
import SlideArrow from "../../Component/Button/SlideArrow";
import { JoinBannerSection, MiddleBannerSection, NewsSection, TopBannerSection, WorkBannerSection, WorkBannerSectionFull } from "./style";
import { newsTab, channelList } from "./meta";
import { kboardDate, stripTags } from "../../util";
import WorkItem from "./WorkItem";
import { theme } from "../../assets/style/theme";
import { responsiveValue } from "../../assets/style/defaultTheme";
import LineBreakOnMobile from "../../Component/Br/LineBreakOnMobile";
import { useForm } from "react-hook-form";
import axios from "axios";

type Props = {};

function Landing({}: Props) {
	const [topBannerCurrent, setTopBannerCurrent] = useState(1);
	const [joinBannerCurrent, setJoinBannerCurrent] = useState(1);
	const [newTabSelected, setNewsTabSelected] = useState(0);
	const [isWorkBannerFull, setIsWorkBannerFull] = useState(false);

	const toast = useToast();

	const { isLoading: topBannerIsLoading, error: errorTopBanner, data: topBanner } = useQuery("getMainBannerTop", () => getMainBanner("top", -1));
	const { isLoading: middleBannerIsLoading, error: errorMiddleBanner, data: middleBanner } = useQuery("getMainBannerMiddle", () => getMainBanner("middle", -1));
	const { isLoading: workBannerIsLoading, error: errorWorkBanner, data: workBanner } = useQuery("getMainBannerWork", () => getMainBanner("work", -1));
	const { isLoading: joinBannerIsLoading, error: errorjoinBanner, data: joinBanner } = useQuery("getMainBannerJoin", () => getMainBanner("join", -1));
	const { isLoading: newsIsLoading, error: errornews, data: news } = useQuery(["getMaiNews", newTabSelected], () => getMainNews(newsTab[newTabSelected].boardId, 3));

	const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

	const topBannerSetting = {
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: <SlideArrow color="gr" />,
		prevArrow: <SlideArrow color="gr" />,
		afterChange: (index: number) => {
			setTopBannerCurrent(index + 1);
		},
	};

	const workBannerSetting = {
		infinite: true,
		centerMode: !isMobile,
		speed: 500,
		slidesToShow: isMobile ? 2 : 3,
		slidesToScroll: !isMobile ? 1 : 2,
		nextArrow: <SlideArrow color="w" />,
		prevArrow: <SlideArrow color="w" />,
		variableWidth: true,
		variableHeight: true,
	};

	const joinBannerSetting = {
		infinite: true,
		centerMode: false,
		centerPadding: "20%",
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: <SlideArrow />,
		prevArrow: <SlideArrow />,
		variableWidth: true,
		variableHeight: true,
		afterChange: (index: number) => {
			setJoinBannerCurrent(index + 1);
		},
	};

	const onClickNewsTab = (item: any, index: number) => {
		setNewsTabSelected(index);
	};

	const sectionSidePadding = { base: "4%", lg: "0" };

	const {
		handleSubmit,
		register,
		formState: { errors },
	} = useForm();

	const onSubscribe = (values: any) => {
		const stibeeEndpoint = "https://stibee.com/api/v1.0/lists/kNI7z7yQacvThCROHW3T3dPVca-T/public/subscribers";
		const formData = new FormData();
		formData.append("email", values.email);
		formData.append("name", values.name);
		axios.post(stibeeEndpoint, formData).then((res) => {
			const msg = res.data.split("<p>")[1].split("</p>")[0];
			toast({
				description: msg,
				status: "success",
				position: "top",
			});
		});
	};

	return (
		<>
			{!topBannerIsLoading && topBanner && (
				<TopBannerSection>
					<Slider {...topBannerSetting}>
						{topBanner.map((item: any, index: number) => (
							<div key={index}>
								<Link href={item.meta.mainbanner_url} target={item.meta.mainbanner_target}>
									{isMobile ? (
										// <Box backgroundImage={item?.meta?.mainbanner_mobile_image?.url}  w="100%" backgroundPosition="50% 50%" backgroundSize="cover" >
										// </Box>
										<Image src={item?.meta?.mainbanner_mobile_image?.url} w="100%" />
									) : (
										<Box backgroundImage={item.featured_full} h={{ base: "480px", lg: "1000px" }} w="100%" backgroundPosition="50% 50%" backgroundSize="cover"></Box>
									)}
								</Link>
							</div>
						))}
					</Slider>
					<div className="current">
						{topBannerCurrent} / {topBanner.length}
					</div>
				</TopBannerSection>
			)}

			{!middleBannerIsLoading && middleBanner && (
				<Box maxW="900" margin="0 auto" pt={{ base: "10", lg: "20" }} pb={{ base: "10", lg: "20" }}>
					<MiddleBannerSection>
						{middleBanner.map((item: any, index: number) => (
							<div key={index}>
								<Link href={item.meta.mainbanner_url} target={item.meta.mainbanner_target}>
									<Image src={item.featured_full} h="54px" objectFit="contain" />
								</Link>
							</div>
						))}
					</MiddleBannerSection>
				</Box>
			)}

			<Box textAlign="center" pt="36" pb="36" pr={sectionSidePadding} pl={sectionSidePadding}>
				<Heading size="2xl" color="b.gr" pb="6">
					재단법인 숲과나눔은
				</Heading>
				<Heading fontSize={{ base: "2.5rem", lg: "3rem" }} color="b.bk" lineHeight="1.2" pb="6">
					숲과 같이 안전하고
					<br />
					지속가능한 사회를 만듭니다
				</Heading>
				<Text pb="6" lineHeight="1.5">
					가정, 일터, 지역사회의 환경이 숲과 같이
					<LineBreakOnMobile />
					건강하고, 안전하며, 지속가능할 수 있도록
					<br />각 분야의 인재 양성, 사회적 난제의 대안 개발과
					<LineBreakOnMobile /> 실천 등을 주요 사업으로 진행하고 있습니다.
				</Text>
				<Button size="lg" colorScheme="dgr" fontSize="xl">
					<a href="http://koreashe.org/intro" target="_blank">
						숲과나눔 사용설명서 바로가기
					</a>
				</Button>
			</Box>

			<Box bgColor="b.dgr" pt={{ base: "16", lg: "40" }} pb={{ base: "16", lg: "44" }} pr={sectionSidePadding} pl={sectionSidePadding}>
				<Box maxW="1200" margin="0 auto" pb="20">
					<Flex>
						<Heading size="4xl" color="b.wh" paddingRight="4">
							숲과나눔 알아보기
						</Heading>
						{!isMobile && (
							<button onClick={() => setIsWorkBannerFull(!isWorkBannerFull)}>
								<Image src="/images/icons/more_w.svg" />
							</button>
						)}
					</Flex>
				</Box>

				{!workBannerIsLoading && workBanner && !isWorkBannerFull && (
					<WorkBannerSection>
						<Slider {...workBannerSetting}>
							{workBanner.map((item: any, index: number) => (
								<WorkItem key={index} item={item} />
							))}
						</Slider>
					</WorkBannerSection>
				)}

				{!workBannerIsLoading && workBanner && isWorkBannerFull && (
					<WorkBannerSectionFull>
						{workBanner.map((item: any, index: number) => (
							<WorkItem key={index} item={item} />
						))}
					</WorkBannerSectionFull>
				)}
			</Box>

			<Box pt={{ base: "16", lg: "32" }} pb={{ base: "20", lg: "52" }} pr={sectionSidePadding} pl={sectionSidePadding}>
				<Box maxW="1200" margin="0 auto" pb={{ base: "10", lg: "20" }}>
					<Flex>
						<Heading size="4xl" color="b.bk" paddingRight="4">
							참여하기
						</Heading>
					</Flex>
				</Box>
				{!joinBannerIsLoading && joinBanner && (
					<JoinBannerSection>
						<Slider {...joinBannerSetting}>
							{joinBanner.map((item: any, index: number) => (
								<div key={index}>
									{item.meta.mainbanner_mode === "direct" && (
										<Link href={item.meta.mainbanner_url} target={item.meta.mainbanner_target}>
											<Box w={{ base: "300px", lg: "588px" }} h={{ base: "300px", lg: "588px" }} borderRadius="24" marginRight="3" marginLeft="3">
												<Image src={item.featured_full} objectFit="cover" />
												{item.meta.mainbanner_register_open === "on" && (
													<Badge className="badge" variant="solid" fontSize="xl" colorScheme="dgr">
														모집중
													</Badge>
												)}
											</Box>
										</Link>
									)}
									{item.meta.mainbanner_mode === "content" && (
										<Link href={`/banner?banner_id=${item.id}`}>
											<Box w={{ base: "300px", lg: "588px" }} h={{ base: "300px", lg: "588px" }} borderRadius="24" marginRight="3" marginLeft="3">
												<Image src={item.featured_full} objectFit="cover" />
												{item.meta.mainbanner_register_open === "on" && (
													<Badge className="badge" variant="solid" fontSize="xl" colorScheme="dgr">
														모집중
													</Badge>
												)}
											</Box>
										</Link>
									)}
								</div>
							))}
						</Slider>
						<div className="current">
							{joinBannerCurrent} / {joinBanner.length}
						</div>
					</JoinBannerSection>
				)}
			</Box>
			<Box bgColor="b.llg" pt={{ base: "12", lg: "32" }} pb={{ base: "16", lg: "32" }} pr={sectionSidePadding} pl={sectionSidePadding}>
				<NewsSection>
					<Box maxW="1200" margin="0 auto" pb={{ base: "8", lg: "14" }}>
						<Flex>
							<Heading size="4xl" color="b.bk" paddingRight="4">
								숲과나눔 최신 소식
							</Heading>
						</Flex>
					</Box>
					<Box maxW="1200" margin="0 auto">
						<Tab list={newsTab} selectedItemIndex={newTabSelected} onClickItem={onClickNewsTab} size={isMobile ? "lg" : "2xl"} />
						{!newsIsLoading && news && (
							<Flex justify="space-between" direction={responsiveValue.flexBoxDirection}>
								{news.items.map((item: any, index: number) => (
									<Link key={index} href={`/board?mode=view&board_id=${item.board_id}&post_id=${item.uid}`}>
										<Box w={{ base: "100%", lg: "sm" }}>
											<Image src={item.featured_full} objectFit="cover" borderRadius="16px 16px 0 0" />
											<Box padding="6" bgColor="b.wh" borderRadius="0 0 16px 16px" minH={{ base: "0", lg: "245px" }}>
												<Heading fontSize="xl" lineHeight="1.4" mb="4" noOfLines={2}>
													{stripTags(item.title)}
												</Heading>
												<Text color="b.g" lineHeight="1.4" mb="5" noOfLines={3}>
													{stripTags(item.content)}
												</Text>
												<Text color="b.g" fontSize="sm" pb="4">
													{kboardDate(item.date)}
												</Text>
											</Box>
										</Box>
									</Link>
								))}
							</Flex>
						)}
						<Center pt="12">
							<a href={`/board/?board_id=${newsTab[newTabSelected].boardId}`}>
								<Button size="lg" colorScheme="dgr">
									{newsTab[newTabSelected].label} 더보기 +
								</Button>
							</a>
						</Center>
					</Box>
				</NewsSection>
			</Box>

			<Box pt={{ base: "12", lg: "36" }} pb={{ base: "12", lg: "36" }} pr={sectionSidePadding} pl={sectionSidePadding} backgroundImage="/images/main/channel_bg.png" backgroundRepeat="no-repeat" backgroundPosition="100% 100%">
				<Box maxW="1200" margin="0 auto" pb="14">
					<Flex>
						<Heading size="4xl" color="b.g" paddingRight="4" lineHeight="1.4">
							다양한 채널을 통해
							<br />
							<Text display="inline" color="b.bk">
								숲과나눔의 소식
							</Text>
							을 만나보세요
						</Heading>
					</Flex>
				</Box>

				<Box maxW="1200" margin="0 auto" pb={{ base: "0", lg: "14" }}>
					<Flex justify="space-between" direction={responsiveValue.flexBoxDirection}>
						{channelList.map((item: any, index: number) => (
							<Link href={item.url} target="_blank" key={index}>
								<Box
									w={{ base: "100%", lg: "282px" }}
									h={{ base: "80px", lg: "260px" }}
									bgColor="b.gr"
									borderRadius="16"
									padding="4"
									key={index}
									borderStyle="solid"
									borderWidth="1px"
									borderColor={item.bg}
									backgroundColor="b.wh"
									boxSizing="border-box"
									mb={{ base: "4", lg: "0" }}
								>
									<Flex direction={{ base: "row", lg: "column" }} alignItems={{ base: "center", lg: "start" }} justifyContent="space-between">
										<Box w="80px" textAlign="center" pl="2">
											<Image src={`/images/icons/${item.value}_c.svg`} h={{ base: "40px", lg: "50px" }} objectFit="cover" mt={{ base: "0", lg: "20" }} mb={{ base: "0", lg: "6" }} />
										</Box>
										<Box flex="1">
											<Flex align="center">
												<Heading size="2xl" color="b.bk" paddingLeft="2">
													{item.label}
												</Heading>
												<Image src="/images/icons/link.svg" w={{ base: "18px", lg: "32px" }} objectFit="cover" />
											</Flex>
											<Text fontSize="md" color="b.bk" paddingLeft="2" paddingTop="2">
												{item.text}
											</Text>
										</Box>
									</Flex>
								</Box>
							</Link>
						))}
					</Flex>
				</Box>
			</Box>
			<Box id="newsletter" pt="16" pb="16" pr={sectionSidePadding} pl={sectionSidePadding} backgroundImage="/images/main/newsletter_bg.png" backgroundRepeat="no-repeat" backgroundPosition="50%% 50%%" backgroundSize="cover">
				<Box maxW="1200" margin="0 auto">
					<Flex justify="space-between" align={{ base: "start", lg: "center" }} direction={responsiveValue.flexBoxDirection}>
						<hgroup>
							<Heading size="4xl" color="b.wh" lineHeight="1.4" pb="4">
								숲과나눔의 다양한 소식을
								<br />
								가장 먼저 받아보세요
							</Heading>
							<Text color="b.wh" lineHeight="1.4" pb={{ base: "6", lg: "0" }}>
								숲과나눔은 재단 활동소식을 전하는 뉴스레터와
								<br />
								환경·안전·보건 분야의 전문적인 정보를 전하는 <a href="/shes-view">SHE's view</a>를 발송하고 있습니다.
							</Text>
						</hgroup>
						<form name="subscribe" onSubmit={handleSubmit(onSubscribe)}>
							<Flex direction={responsiveValue.flexBoxDirection} alignItems="start">
								<FormControl id="email" pb={{ base: "2", lg: "0" }} isInvalid={errors.email}>
									<Input size="lg" w={{ base: "300px", lg: "282px" }} type="email" placeholder="이메일주소를 입력해주세요" {...register("email", { required: true })} />
									<FormErrorMessage color="b.wh">이메일은 필수 항목입니다.</FormErrorMessage>
								</FormControl>
								<FormControl id="name" pl={{ base: "0", lg: "4" }} pb={{ base: "2", lg: "0" }} isInvalid={errors.name}>
									<Input size="lg" w={{ base: "300px", lg: "180px" }} type="text" placeholder="이름을 입력해주세요" {...register("name", { required: true })} />
									<FormErrorMessage color="b.wh">이름은 필수 항목입니다.</FormErrorMessage>
								</FormControl>
								<FormControl id="name" pl={{ base: "0", lg: "4" }}>
									<Button type="submit" size="lg" fontSize="md" colorScheme="dgr" borderRadius="8">
										구독하기
									</Button>
								</FormControl>
							</Flex>
						</form>
					</Flex>
				</Box>
			</Box>
		</>
	);
}

Landing.defaultProps = {};

export default Landing;
